import React, { createContext, useReducer } from "react";

const ModalsContext = createContext(null);

function modalsReducer(state, action) {
    switch(action.type) {
        case "OPEN_MODAL":
        return {
            ...state,
            modal: action.payload,
        };
        case "CLOSE_MODAL":
            return {
                ...state,
                modal: undefined,
            };
       default:
          return state;
    }
 }

const initialState = {
    modal: undefined,
}

export function ModalsContextProvider({ children }) {
    const [state, dispatch] = useReducer(modalsReducer, initialState);

    function openModal(modal) {
      dispatch({
        type: "OPEN_MODAL",
        payload: modal,
      });
    }
 

    function closeModal() {
      dispatch({
        type: "CLOSE_MODAL",
      });
    }

    return (
      <ModalsContext.Provider
        value={{
          openModal,
          closeModal,
          modal: state.modal,
        }}
      >
      {children}
      </ModalsContext.Provider>
    );
  }

  export default ModalsContext;